import { CurrencyEnum } from './currency-enum';

export class BidHistoryItem {
  offerPrice: number;
  effectiveDate: Date;
  currency: CurrencyEnum;
  offerPriceInCurrency: number;
}
